
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import beaconModule from '@/store/beacon'
import whitelabelModule from '@/store/whitelabel'
import { TextFieldRules } from '@/utils/enums'
import { Beacon } from '@/types/Beacon'

@Component({
  name: 'BeaconEditor'
})
class BeaconEditor extends Vue {
  @Prop() readonly edit?: boolean
  private rules = TextFieldRules

  private form: Partial<Beacon> = {
    uuid: '',
    major: 1,
    minor: 1
  }

  private get beacon(): Beacon | undefined {
    return beaconModule.beacon
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
  }

  private get whitelabels() {
    return whitelabelModule.whitelabels
  }

  @Watch('beacon')
  private async setBeacon(): Promise<void> {
    if (!this.edit) return
    this.form = JSON.parse(JSON.stringify(this.beacon))
  }

  private created(): void {
    this.setBeacon()
  }

  private async saveBeacon(): Promise<void> {
    Object.assign(this.form, { whitelabel: this.whitelabel })
    if (!this.edit) {
      beaconModule.create(this.form)
    } else {
      beaconModule.update(this.form)
    }
    document.dispatchEvent(new Event('close-beacon'))
  }
}

export default BeaconEditor
